var exports = {
  "kL": "x4ddf2309--e84bd2--container",
  "Qs": "x4ddf2309--e84bd2--content",
  "AS": "x4ddf2309--e84bd2--item",
  "YR": "x4ddf2309--e84bd2--item-icon",
};

module.exports = exports;
